import type { User } from '../types/user'
import type { Patient } from '../types/patient'

export function formatUserName(user: Pick<User, 'firstName' | 'lastName' | 'salutation'>): string {
  return user.salutation
    ? `${user.salutation} ${user.firstName} ${user.lastName}`
    : `${user.firstName} ${user.lastName}`
}

/** Format doctor name for PCRS claim submission (docNam): "DR. FIRSTNAME LASTNAME" uppercase. */
export function formatDoctorNameForClaim(user: Pick<User, 'firstName' | 'lastName'>): string {
  const first = (user.firstName || '').trim()
  const last = (user.lastName || '').trim()
  const name = [first, last].filter(Boolean).join(' ').toUpperCase()
  return name ? `DR. ${name}` : 'DR.'
}

export function formatPatientName(
  patient: Pick<Patient, 'firstName' | 'lastName' | 'salutation'> | null | undefined
): string {
  if (!patient) {
    return 'Unknown Patient'
  }
  
  const firstName = patient.firstName || ''
  const lastName = patient.lastName || ''
  
  if (!firstName && !lastName) {
    return 'Unknown Patient'
  }
  
  const name = `${firstName} ${lastName}`.trim()
  
  return patient.salutation
    ? `${patient.salutation} ${name}`
    : name
}


